module.exports = __webpack_public_path__ + "img/power-dev-bg-1.d1a214cd.png";